import React from 'react';
import { ForgeDialog, ForgeButton } from '@tylertech/forge-react';
import { FeatureFlags } from 'common/feature_flags';

interface ProcessDisconveryEmbedModalProps {
  showModal?: boolean;
  url: string;
  onDismiss: () => void;
}

const ProcessDisconveryEmbedModal = ({ url, onDismiss, showModal }: ProcessDisconveryEmbedModalProps) => (
  <ForgeDialog open={showModal} on-forge-dialog-close={onDismiss}>
    <div className="process-discovery-modal-body" data-testid="process-discovery-modal-body">
      <iframe src={url} style={{ width: '100%', height: '100%' }} />
      {FeatureFlags.valueOrDefault('enable_eerp_modal_close_button_workaround', false) ? (
        <ForgeButton className="hacked-close-button" variant="raised" onClick={onDismiss}>
          Close
        </ForgeButton>
      ) : null}
    </div>
  </ForgeDialog>
);

export default ProcessDisconveryEmbedModal;
